const TroncosHome = () => import(/* webpackChunkName: "group-pabx-cadastros-troncos" */ '../_views/TroncosHome')
const CadastroTroncos = () => import(/* webpackChunkName: "group-pabx-cadastros-troncos" */ '../_views/CadastroTroncos')
const AtualizarTroncos = () =>
  import(/* webpackChunkName: "group-pabx-cadastros-troncos" */ '../_views/AtualizarTroncos')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'troncos',
    component: TroncosHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Troncos',
  },
  {
    path: 'troncos/criar',
    component: CadastroTroncos,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'CriarTroncos',
  },
  {
    path: 'troncos/atualizar/:_id',
    component: AtualizarTroncos,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'troncos/atualizar',
    props: true,
  },
]
